import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

const DownloadAppScreen = ({ onContinue }) => {
    const { t } = useTranslation();

    const handleDownloadApp = () => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;

        // Détecter le type d'appareil et rediriger vers le store approprié dans une nouvelle fenêtre
        if (/android/i.test(userAgent)) {
            window.open('https://play.google.com/store/apps/details?id=com.qovoltis.client', '_blank');
        } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            window.open('https://apps.apple.com/fr/app/qovoltis/1524983586', '_blank');
        } else {
            // Par défaut, rediriger vers app store dans une nouvelle fenêtre
            window.open('https://apps.apple.com/fr/app/qovoltis/1524983586', '_blank');
        }
    };

    return (
        <div className="flex flex-col items-center justify-center p-4 bg-white min-h-screen">
            <div className="w-full max-w-md space-y-6">
                <div className="text-center">
                    <img
                        src="/logo_qovoltis.svg"
                        alt="Qovoltis App"
                        className="w-48 h-48 mx-auto mb-4"
                    />
                    <h2 className="text-2xl font-bold text-gray-800 mb-2">
                        {t("downloadApp.title")}
                    </h2>
                    <p className="text-gray-600 text-center">
                        {t("downloadApp.description")}
                    </p>
                </div>

                <div className="flex justify-center space-x-4">
                    <img
                        src="/google-play-badge.svg"
                        alt="Google Play"
                        className="h-10 cursor-pointer"
                        onClick={() => window.open('https://play.google.com/store/apps/details?id=com.qovoltis.client', '_blank')}
                    />
                    <img
                        src="/app-store-badge.svg"
                        alt="App Store"
                        className="h-10 cursor-pointer"
                        onClick={() => window.open('https://apps.apple.com/fr/app/qovoltis/1524983586', '_blank')}
                    />
                </div>

                {/* <div className="bg-blue-50 rounded-lg p-4 space-y-3">
                    <div className="flex items-center space-x-3">
                        <div className="w-10 h-10 bg-blue-500 rounded-full flex items-center justify-center text-white">
                            1
                        </div>
                        <p className="text-gray-700">{t("downloadApp.features.feature1")}</p>
                    </div>
                    <div className="flex items-center space-x-3">
                        <div className="w-10 h-10 bg-blue-500 rounded-full flex items-center justify-center text-white">
                            2
                        </div>
                        <p className="text-gray-700">{t("downloadApp.features.feature2")}</p>
                    </div>
                    <div className="flex items-center space-x-3">
                        <div className="w-10 h-10 bg-blue-500 rounded-full flex items-center justify-center text-white">
                            3
                        </div>
                        <p className="text-gray-700">{t("downloadApp.features.feature3")}</p>
                    </div>
                    <div className="flex items-center space-x-3">
                        <div className="w-10 h-10 bg-blue-500 rounded-full flex items-center justify-center text-white">
                            4
                        </div>
                        <p className="text-gray-700">{t("downloadApp.features.feature4")}</p>
                    </div>
                </div> */}


                <div className="flex flex-col space-y-3">
                    <button
                        onClick={handleDownloadApp}
                        className="bg-indigo-600 text-white py-3 px-4 w-50 rounded-lg font-medium hover:bg-indigo-700 transition-colors"
                    >
                        {t("downloadApp.downloadButton")}
                    </button>
                    <button
                        onClick={onContinue}
                        className="bg-gray-200 text-gray-800 py-3 px-4 w-50 rounded-lg font-medium hover:bg-gray-300 transition-colors"
                    >
                        {t("downloadApp.continueWithoutApp")}
                    </button>
                </div>

            </div>
        </div>
    );
};

export default DownloadAppScreen;